import styled, { css } from 'styled-components';

import ColorConstants from '@shared/constants/ColorConstants';
import Checkbox from '@shared/components/inputs/checkboxes/Checkbox';
import { FlexDiv } from '@shared/components/base/Div';

export const Wrapper = styled(FlexDiv)`
    justify-content: flex-start;
    margin-top: 7px;
    max-height: 100px;
    flex: 0 0 31px;
    transition: max-height 0.5s ease 0s, margin 0.5s ease 0s;
    
    &:hover {
        transition: all 0.2s ease-out;    
        background-color: ${ColorConstants['catskill-white']};
    }
    
    ${({ isVisible }) => !isVisible && css`
        margin-top: 0px;
        border: 0px solid;
        max-height: 0px;
        height: 0px;
        overflow: hidden;
    `}
`;

export const StyledCheckBox = styled(Checkbox)`
    margin: 6px 0px; 
`;
